module.exports = __webpack_public_path__ + "static/media/mobile-app-promotion-fr.49877cd2.png";